import { TagDto } from '@shared/dto';
import { createReducer, on } from '@ngrx/store';
import * as TagActions from './tag.actions';
import { State } from '@store/state.interface';

export const TAG_FEATURE_KEY = 'tags';

export interface TagState extends State<TagDto> {}

export const initialState: TagState = {
  data: null,
  detail: null,
  total: 0,
  query: null,
  loading: false,
  error: null,
};

export const tagReducer = createReducer(
  initialState,
  on(TagActions.readTags, (state, { query }) => ({
    ...state,
    loading: true,
    error: null,
    query: query ?? null,
  })),
  on(TagActions.readTagsSuccess, (state, { data, total }) => ({ ...state, data, total, loading: false })),
  on(TagActions.readTagsFailure, (state, { error }) => ({ ...state, error, loading: false })),

  on(TagActions.readTag, (state) => ({ ...state, detail: null, loading: true, error: null })),
  on(TagActions.readTagSuccess, (state, { tag }) => ({ ...state, detail: tag, loading: false })),
  on(TagActions.readTagFailure, (state, { error }) => ({ ...state, error, loading: false })),

  // Writes do not patch `data`: every success re-dispatches `readTags`, so the
  // list is whatever the server says. Only the in-flight flag and the error are
  // tracked here.
  on(TagActions.createTag,
    TagActions.updateTag,
    TagActions.deleteTag,
    TagActions.restoreTag,
    (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(
    TagActions.createTagSuccess,
    TagActions.updateTagSuccess,
    TagActions.deleteTagSuccess,
    TagActions.restoreTagSuccess,
    (state) => ({ ...state, loading: false }),
  ),
  on(
    TagActions.createTagFailure,
    TagActions.updateTagFailure,
    TagActions.deleteTagFailure,
    TagActions.restoreTagFailure,
    (state, { error }) => ({ ...state, error, loading: false }),
  ),
  // Not a failure: the delete is waiting on the user, so the spinner stops but
  // nothing is recorded as broken.
  on(TagActions.deleteTagRequiresConfirmation, (state) => ({ ...state, loading: false })),
);
